function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { from, of } from "rxjs";
import { catchError, concatMap, distinctUntilChanged, flatMap, map, take, tap } from "rxjs/operators";
import { BalanceProvider } from "trade_asset_lib";
import { QuotationSocketMgr } from "trade_quotation_lib";
import { getTradeDependencyInstance, PRODUCT_TYPE } from "trade_utils_lib";
import { AccountWebSocket, createFakeFutureAPI, createFutureAPI, createWebFakeAPI, createWebTradeAPI, ExchangeID, ExchangeOrderType, getBotSupportMarketList, mergeCloudMarketDescInfo, TradeUtils } from "TradeAPILib";
import SymbolDataProvider from "../symbols/SymbolDataProvider";
import { requestWithRetry } from "../utils/Api";
import { groupBotOrderList } from "./ExchangeDataProviderTools";
import ExchangeSymbolCacheManager from "./ExchangeSymbolCacheManager";
var ExchangeDataProvider = /*#__PURE__*/function () {
  //交易库接口

  function ExchangeDataProvider(api, futureApi) {
    _classCallCheck(this, ExchangeDataProvider);
    _defineProperty(this, "api", void 0);
    _defineProperty(this, "futureApi", void 0);
    _defineProperty(this, "symbol", {
      symbol: "BTC/USDT",
      base: "BTC",
      quote: "USDT",
      isLeverage: false,
      baseDisplay: "BTC",
      quoteDisplay: "USDT"
    });
    _defineProperty(this, "topAIGridStrategy", undefined);
    this.api = api;
    this.futureApi = futureApi;
    if (!ExchangeDataProvider.websocketManager) {
      ExchangeDataProvider.websocketManager = new QuotationSocketMgr({
        disableCache: true
      });
    }
  }
  _createClass(ExchangeDataProvider, [{
    key: "getExchangeSymbols",
    value: function getExchangeSymbols() {
      var _this = this;
      var forceNet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var symbols = this.api.getDefaultSymbols();
      if (!forceNet && symbols && symbols.length > 0) {
        return of(symbols);
      }
      return requestWithRetry(this.api.getRawSymbols()).pipe(tap(function (symbols) {
        ExchangeSymbolCacheManager.set(_this.api.getExchangeName(), symbols);
      }));
    }
  }, {
    key: "setSymbol",
    value: function setSymbol(symbol) {
      this.symbol = symbol;
    }

    //获取rest ticker数据
  }, {
    key: "queryRestSymbolTicker",
    value: function queryRestSymbolTicker() {
      return requestWithRetry(this.api.queryRestSymbolTicker(this.symbol.base, this.symbol.quote));
    }

    //获取交易所当前交易对订单信息
  }, {
    key: "getMarketTradesDataObservable",
    value: function getMarketTradesDataObservable() {
      return requestWithRetry(this.api.getTrades(this.symbol.base, this.symbol.quote));
    }

    //订阅交易对ticker信息
  }, {
    key: "getBUTickerObservablesWithSymbolList",
    value: function getBUTickerObservablesWithSymbolList(market, symbolList) {
      return requestWithRetry(this.api.getMarketWSTickerObservable(market, symbolList));
    }

    // grid pro
  }, {
    key: "getGridProWithSymbolCart",
    value: function getGridProWithSymbolCart() {
      return requestWithRetry(this.api.requestGridProPairsBearishRatio(this.symbol.base, this.symbol.quote));
    }
  }, {
    key: "querySymbolTickerPrice",
    value: function querySymbolTickerPrice(base, quote) {
      return requestWithRetry(this.api.querySymbolTicker(base, quote));
    }

    /**
     * check用户网格启动条件
     * @param requestBodyParam
     * @returns {Observable<GridRequireResult>}
     */
  }, {
    key: "checkGridRequireBalance",
    value: function checkGridRequireBalance(requestBodyParam) {
      return requestWithRetry(this.api.checkGridRequireBalance(requestBodyParam));
    }

    /**
     * check用户无限网格启动条件
     * @param requestBodyParam
     * @returns {Observable<GridRequireResult>}
     */
  }, {
    key: "checkIGBalanceEnough",
    value: function checkIGBalanceEnough(requestBodyParam) {
      return requestWithRetry(this.api.checkIGBalanceEnough(requestBodyParam));
    }
  }, {
    key: "requestAIStrategyItem",
    value: function requestAIStrategyItem(market, base, quote) {
      return requestWithRetry(this.api.requireAIStrategyWithSymbol(market, base, quote));
    }
  }, {
    key: "requestIGAIStrategy",
    value: function requestIGAIStrategy(market, base, quote) {
      return requestWithRetry(this.api.requireIGAIStrategy(market, base, quote));
    }
  }, {
    key: "requireGridPervolume",
    value: function requireGridPervolume(param) {
      return requestWithRetry(this.api.requireGridPervolume(param));
    }

    //监听当前key正在运行订单数据流刷新
  }, {
    key: "getCustomOpenOrderObservable",
    value: function getCustomOpenOrderObservable() {
      return requestWithRetry(this.api.queryCustomOrders(this.symbol.base, this.symbol.quote, true)).pipe(map(function (orders) {
        return orders.sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
      }));
    }

    //获取当前key已成功订单
  }, {
    key: "getCustomCompleteOrderDataObserver",
    value: function getCustomCompleteOrderDataObserver() {
      return requestWithRetry(this.api.queryCustomOrders(this.symbol.base, this.symbol.quote, false)).pipe(map(function (orders) {
        return orders.sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
      }));
    }

    /**
     * 获取pionex订单的分页接口
     * @param param
     * @param queryOpen
     */
  }, {
    key: "getCustomOrderObservablePage",
    value: function getCustomOrderObservablePage(param, queryOpen, repeat) {
      return requestWithRetry(this.api.queryCustomOrderPage(Object.assign(param, {
        includeStrategy: false
      }), queryOpen, repeat)).pipe(map(function (orders) {
        return orders.sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
      }));
    }

    /**
     *  分页获取当前交易所下面的策略订单
     * @param pageNo
     * @param pageNum
     * @param status
     */
  }, {
    key: "getQueryByStatusMarketBotOrdersMore",
    value: function getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote) {
      return requestWithRetry(this.api.getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote));
    }

    /**
     * 获取当前交易所下面的策略订单数量
     * @param status
     */
  }, {
    key: "getBotTypeBalanceObservable",
    value: function getBotTypeBalanceObservable() {
      return requestWithRetry(this.api.getBotTypeBalance());
    }
  }, {
    key: "getMarketBotOrdersCountByStatus",
    value: function getMarketBotOrdersCountByStatus(params) {
      return requestWithRetry(this.api.getMarketBotOrdersCountByStatus(params));
    }

    /**
     * 分页获取当前交易所下面的策略订单V2 (传入对象化)
     * @param apiKey
     * @param param
     */
  }, {
    key: "getQueryByStatusMarketBotOrdersMoreV2",
    value: function getQueryByStatusMarketBotOrdersMoreV2(param) {
      return requestWithRetry(this.api.getQueryBotOrdersMoreV2(param));
    }

    /**
     * 获取当前交易所下面的已经分类的策略订单
     */
  }, {
    key: "getBotOrderCollectionWithMarket",
    value: function getBotOrderCollectionWithMarket() {
      var _this2 = this;
      return requestWithRetry(this.api.getQueryMarketAllBotOrders()).pipe(map(function (list) {
        return groupBotOrderList(list, _this2.symbol);
      }));
    }
  }, {
    key: "getTopGridAIStrategy",
    value: function getTopGridAIStrategy() {
      var _this3 = this;
      if (this.topAIGridStrategy) {
        return of(this.topAIGridStrategy);
      }
      return from(this.api.requireTopGridAIStrategy(this.api.market)).pipe(tap(function (data) {
        _this3.topAIGridStrategy = data;
      }));
    }

    /**
     * 获取网格交易close订单详情信息-分页接口
     * @param orderId
     * @param limit
     * @param orderType
     * @returns {Observable<T>}
     */
  }, {
    key: "getGridCloseOrdersObservable",
    value: function getGridCloseOrdersObservable(orderId, limit, orderType) {
      throw "待修改";
      // return this.api.getQueryGridCloseOrdersOnce(orderId, limit, orderType);
    }

    /**
     * 获取AIP订单历史
     * @param orderId
     * @param pgno
     * @param pgnm
     */
  }, {
    key: "getAIPCloseOrdersObservable",
    value: function getAIPCloseOrdersObservable(orderId) {
      var pgno = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var pgnm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      return this.api.queryAIPOrTWAPCustomOrdersOnce(orderId, pgno, pgnm);
    }

    //订阅交易所ticker信息
  }, {
    key: "getExchangeTickerObservable",
    value: function getExchangeTickerObservable() {
      return ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservable(ExchangeID.PIONEXV2);
    }
  }, {
    key: "getExchangeTickerObservableWithSymbolList",
    value: function getExchangeTickerObservableWithSymbolList(symbolList) {
      return ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservable(ExchangeID.PIONEXV2).pipe(map(function (data) {
        var result = [];
        symbolList.forEach(function (symbol) {
          var key = "".concat(symbol.base, "/").concat(symbol.quote);
          if (data.has(key)) {
            result.push(data.get(key));
          }
        });
        return result;
      }));
    }

    // 获取策略交易评测详情
  }, {
    key: "requestStrategyScores",
    value: function requestStrategyScores() {
      var _this4 = this;
      return requestWithRetry(function () {
        return _this4.api.requestStrategyScores();
      });
    }

    // 获取网格2.0 牛熊走势
  }, {
    key: "requestGridProPairsBearishRatio",
    value: function requestGridProPairsBearishRatio(base, quote) {
      var _this5 = this;
      return requestWithRetry(function () {
        return _this5.api.requestGridProPairsBearishRatio(base, quote);
      });
    }

    /**
     * 获取当前交易所下面的所有策略订单websocket更新
     */
  }, {
    key: "getWebSocketMarketBotOrders",
    value: function getWebSocketMarketBotOrders() {
      var _this6 = this;
      return ExchangeDataProvider.accountWebSocket.getBotOrderObservable().pipe(distinctUntilChanged(function (obj1, obj2) {
        if (obj1.id === obj2.id) {
          if (obj1.orderType === obj2.orderType) {
            switch (obj2.orderType) {
              case ExchangeOrderType.grid:
                return obj1.state === obj2.state && obj1.exchangeGridOrder.totalInvest === obj2.exchangeGridOrder.totalInvest && obj1.exchangeGridOrder.transactionAmount === obj2.exchangeGridOrder.transactionAmount && obj1.closeTimestamp === obj2.closeTimestamp;
              case ExchangeOrderType.ig:
                return obj1.state === obj2.state && obj1.exchangeIGOrder.totalInvest === obj2.exchangeIGOrder.totalInvest && obj1.exchangeIGOrder.transactionAmount === obj2.exchangeIGOrder.transactionAmount && obj1.closeTimestamp === obj2.closeTimestamp && obj1.exchangeIGOrder.latestBaseAmount === obj2.exchangeIGOrder.latestBaseAmount && obj1.exchangeIGOrder.latestQuoteAmount === obj2.exchangeIGOrder.latestQuoteAmount;
              case ExchangeOrderType.gridPro:
                return obj1.state === obj2.state && obj1.exchangeGridProOrder.totalInvest === obj2.exchangeGridProOrder.totalInvest && obj1.exchangeGridProOrder.trx_history === obj2.exchangeGridProOrder.trx_history && obj1.closeTimestamp === obj2.closeTimestamp && obj1.exchangeGridProOrder.triggerTime === obj2.exchangeGridProOrder.triggerTime && obj1.innerStatus === obj2.innerStatus && obj1.exchangeGridProOrder.baseAmount === obj2.exchangeGridProOrder.baseAmount && obj1.exchangeGridProOrder.quoteAmount === obj2.exchangeGridProOrder.quoteAmount &&
                //下列为提取利润相关
                obj1.exchangeGridProOrder.profitWithdrawn === obj2.exchangeGridProOrder.profitWithdrawn && obj1.exchangeGridProOrder.latestQuoteAmount === obj2.exchangeGridProOrder.latestQuoteAmount && obj1.exchangeGridProOrder.baseFeeReserve === obj2.exchangeGridProOrder.baseFeeReserve && obj1.exchangeGridProOrder.quoteFeeReserve === obj2.exchangeGridProOrder.quoteFeeReserve;
              case ExchangeOrderType.gridClassic:
                return obj1.state === obj2.state && obj1.exchangeGridClassicOrder.totalInvest === obj2.exchangeGridClassicOrder.totalInvest && obj1.exchangeGridClassicOrder.trx_history === obj2.exchangeGridClassicOrder.trx_history && obj1.closeTimestamp === obj2.closeTimestamp && obj1.exchangeGridClassicOrder.triggerTime === obj2.exchangeGridClassicOrder.triggerTime && obj1.innerStatus === obj2.innerStatus && obj1.exchangeGridClassicOrder.baseAmount === obj2.exchangeGridClassicOrder.baseAmount && obj1.exchangeGridClassicOrder.quoteAmount === obj2.exchangeGridClassicOrder.quoteAmount;
              case ExchangeOrderType.gridLeverage:
                return obj1.state === obj2.state && obj1.exchangeLeverageGridOrder.totalInvest === obj2.exchangeLeverageGridOrder.totalInvest && obj1.exchangeLeverageGridOrder.trx_history === obj2.exchangeLeverageGridOrder.trx_history && obj1.closeTimestamp === obj2.closeTimestamp && obj1.exchangeLeverageGridOrder.liquidatedTriggered === obj2.exchangeLeverageGridOrder.liquidatedTriggered && obj1.exchangeLeverageGridOrder.triggerTime === obj2.exchangeLeverageGridOrder.triggerTime && obj1.exchangeLeverageGridOrder.liquidatedPrice === obj2.exchangeLeverageGridOrder.liquidatedPrice && obj1.innerStatus === obj2.innerStatus && obj1.exchangeLeverageGridOrder.baseAmount === obj2.exchangeLeverageGridOrder.baseAmount && obj1.exchangeLeverageGridOrder.quoteAmount === obj2.exchangeLeverageGridOrder.quoteAmount && obj1.exchangeLeverageGridOrder.loanCoin === obj2.exchangeLeverageGridOrder.loanCoin;
              case ExchangeOrderType.gridLoan:
                return obj1.state === obj2.state && obj1.exchangeLoanGridOrder.totalInvest === obj2.exchangeLoanGridOrder.totalInvest && obj1.exchangeLoanGridOrder.trx_history === obj2.exchangeLoanGridOrder.trx_history && obj1.closeTimestamp === obj2.closeTimestamp && obj1.exchangeLoanGridOrder.liquidatedTriggered === obj2.exchangeLoanGridOrder.liquidatedTriggered && obj1.exchangeLoanGridOrder.triggerTime === obj2.exchangeLoanGridOrder.triggerTime && obj1.exchangeLoanGridOrder.liquidatedPrice === obj2.exchangeLoanGridOrder.liquidatedPrice && obj1.innerStatus === obj2.innerStatus && obj1.exchangeLoanGridOrder.baseAmount === obj2.exchangeLoanGridOrder.baseAmount && obj1.exchangeLoanGridOrder.quoteAmount === obj2.exchangeLoanGridOrder.quoteAmount && obj1.exchangeLoanGridOrder.loanCoin === obj2.exchangeLoanGridOrder.loanCoin;
              case ExchangeOrderType.gridShort:
                return obj1.state === obj2.state && obj1.exchangeShortGridOrder.totalInvest === obj2.exchangeShortGridOrder.totalInvest && obj1.exchangeShortGridOrder.trx_history === obj2.exchangeShortGridOrder.trx_history && obj1.closeTimestamp === obj2.closeTimestamp && obj1.exchangeShortGridOrder.triggerTime === obj2.exchangeShortGridOrder.triggerTime && obj1.innerStatus === obj2.innerStatus && obj1.exchangeShortGridOrder.baseAmount === obj2.exchangeShortGridOrder.baseAmount && obj1.exchangeShortGridOrder.quoteAmount === obj2.exchangeShortGridOrder.quoteAmount &&
                //下列为提取利润相关
                obj1.exchangeShortGridOrder.profitWithdrawn === obj2.exchangeShortGridOrder.profitWithdrawn && obj1.exchangeShortGridOrder.latestQuoteAmount === obj2.exchangeShortGridOrder.latestQuoteAmount && obj1.exchangeShortGridOrder.baseFeeReserve === obj2.exchangeShortGridOrder.baseFeeReserve && obj1.exchangeShortGridOrder.quoteFeeReserve === obj2.exchangeShortGridOrder.quoteFeeReserve;
              default:
                return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      })).pipe(concatMap(function (exchangeOrder) {
        if (exchangeOrder.exchange !== _this6.api.getInnerApiKeyInfo().market) {
          return of(undefined);
        }
        return ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservableByPair(ExchangeID.PIONEXV2, exchangeOrder.base, exchangeOrder.quote).pipe(take(1)).pipe(map(function (exchangeTicker) {
          var latestPrice = exchangeTicker.latest;
          switch (exchangeOrder.orderType) {
            case ExchangeOrderType.grid:
              {
                exchangeOrder.exchangeGridOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.trailingStop:
              {
                exchangeOrder.exchangeTrailingStopLimitOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.aip:
              {
                exchangeOrder.exchangeAIPOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.ig:
              {
                exchangeOrder.exchangeIGOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridPro:
              {
                exchangeOrder.exchangeGridProOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridClassic:
              {
                exchangeOrder.exchangeGridClassicOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridLoan:
              {
                exchangeOrder.exchangeLoanGridOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridShort:
              {
                exchangeOrder.exchangeShortGridOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridLeverage:
              {
                exchangeOrder.exchangeLeverageGridOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridFuture:
              {
                exchangeOrder.exchangeFutureGridOrder.latestPrice = latestPrice;
                break;
              }
            case ExchangeOrderType.gridLeverageShort:
              {
                exchangeOrder.exchangeLeverageShortGridOrder.latestPrice = latestPrice;
                break;
              }
            default:
              {
                break;
              }
          }
          return TradeUtils.calcGridOrderProfit(exchangeOrder, latestPrice);
        })).pipe(catchError(function (err) {
          console.log(err);
          return of(exchangeOrder);
        }));
      })).pipe(map(function (data) {
        if (data === undefined) {
          return [];
        } else {
          return [data];
        }
      }));
    }
  }, {
    key: "queryGridProBalanceSequence",
    value:
    // 获取用户网格订单的资产变化曲线
    function queryGridProBalanceSequence(orderType, orderId) {
      return this.api.queryGridProBalanceSequence(orderType, orderId);
    }
  }], [{
    key: "create",
    value: function create(apiKey) {
      return from(createWebTradeAPI(apiKey.exchange, apiKey.key_id)).pipe(map(function (api) {
        return new ExchangeDataProvider(api, createFutureAPI(apiKey));
      }));
    }
  }, {
    key: "getPublicExchangeDataProvider",
    value: function getPublicExchangeDataProvider(exchange) {
      var cachedExchangeDataProvider = ExchangeDataProvider.publicExchangeDataProviderCache.get(exchange);
      if (cachedExchangeDataProvider) {
        return cachedExchangeDataProvider;
      }
      var exchangeDataProvider = new ExchangeDataProvider(createWebFakeAPI(exchange), createFakeFutureAPI(exchange));
      ExchangeDataProvider.publicExchangeDataProviderCache.set(exchange, exchangeDataProvider);
      var exchangeSymbolCache = ExchangeSymbolCacheManager.get(exchange);
      if (exchangeSymbolCache && exchangeSymbolCache.symbols) {
        exchangeDataProvider.api.setExchangeSymbols(exchangeSymbolCache.symbols);
      }
      return exchangeDataProvider;
    }
  }, {
    key: "getExchangeDataProvider",
    value: function getExchangeDataProvider(apiKey) {
      var cachedExchangeDataProvider = ExchangeDataProvider.exchangeDataProviderCache.get(apiKey.key_id);
      if (cachedExchangeDataProvider) {
        return of(cachedExchangeDataProvider);
      }
      return from(createWebTradeAPI(apiKey.exchange, apiKey.key_id)).pipe(map(function (api) {
        var exchangeSymbolCache = ExchangeSymbolCacheManager.get(apiKey.exchange);
        if (exchangeSymbolCache && exchangeSymbolCache.symbols) {
          api.setExchangeSymbols(exchangeSymbolCache.symbols);
        }
        return new ExchangeDataProvider(api, createFutureAPI(apiKey));
      })).pipe(tap(function (exchangeDataProvider) {
        if (apiKey.key_id) {
          ExchangeDataProvider.exchangeDataProviderCache.set(apiKey.key_id, exchangeDataProvider);
        }
      }));
    }
  }, {
    key: "getExchangeSymbol",
    value: function getExchangeSymbol(pair) {
      return ExchangeDataProvider.getPublicExchangeDataProvider(pair.exchange).api.getSymbol(pair.base, pair.quote);
    }
  }, {
    key: "getBotOrdersCountObservable",
    value: function getBotOrdersCountObservable(apiKey, param) {
      return ExchangeDataProvider.getExchangeDataProvider(apiKey).pipe(flatMap(function (exchangeDataProvider) {
        return exchangeDataProvider.getMarketBotOrdersCountByStatus(param);
      }));
    }
  }, {
    key: "getQueryBotOrdersMoreObservable",
    value: function getQueryBotOrdersMoreObservable(apiKey, param) {
      return ExchangeDataProvider.getExchangeDataProvider(apiKey).pipe(flatMap(function (exchangeDataProvider) {
        return exchangeDataProvider.getQueryByStatusMarketBotOrdersMoreV2(param);
      }));
    }
  }, {
    key: "makeBotSupportMarketForceCloud",
    value: function makeBotSupportMarketForceCloud() {
      var updateResult = getBotSupportMarketList().map(function (market) {
        return _defineProperty({}, market, {
          useCloud: true
        });
      });
      mergeCloudMarketDescInfo(updateResult);
    }
  }, {
    key: "init",
    value: function init(tradeDependency) {
      var _tradeDependency$getP;
      this.makeBotSupportMarketForceCloud();
      ///> 初始化BalanceProvider
      BalanceProvider.setRetrieveApiInterface(function (apiKey) {
        return ExchangeDataProvider.getExchangeDataProvider({
          exchange: apiKey.market,
          key_id: apiKey.cloudKeyId,
          alias: ""
        }).pipe(map(function (dataProvider) {
          return dataProvider.api;
        }));
      });
      var isPionex = ((_tradeDependency$getP = tradeDependency.getPlatform) === null || _tradeDependency$getP === void 0 ? void 0 : _tradeDependency$getP.call(tradeDependency)) === PRODUCT_TYPE.PIONEX;
      getTradeDependencyInstance().setTradeDependency(_objectSpread(_objectSpread({}, tradeDependency), {}, {
        getTickerWsStream: function getTickerWsStream() {
          return ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservable(ExchangeID.PIONEXV2);
        },
        getMarketSymbol: function getMarketSymbol(market) {
          if (isPionex) {
            var symbolData = SymbolDataProvider.getSymbolData();
            return symbolData.allSymbols || [];
          } else {
            return ExchangeDataProvider.getPublicExchangeDataProvider(market).api.getDefaultSymbols();
          }
        }
      }));
      if (!ExchangeDataProvider.websocketManager) {
        ExchangeDataProvider.websocketManager = new QuotationSocketMgr({
          disableCache: true
        });
      }
    }
  }]);
  return ExchangeDataProvider;
}();
_defineProperty(ExchangeDataProvider, "publicExchangeDataProviderCache", new Map());
_defineProperty(ExchangeDataProvider, "exchangeDataProviderCache", new Map());
_defineProperty(ExchangeDataProvider, "accountWebSocket", new AccountWebSocket({}));
_defineProperty(ExchangeDataProvider, "websocketManager", void 0);
export { ExchangeDataProvider as default };